import script from "./Tooth23.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooth23.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__